require('../../../shared/css/main.scss');
require('../../../shared/css/navbar.scss');
require('../../../shared/css/footer.scss');

require('../../../shared/css/flex.scss');

require('../css/index.scss');

var navbar = require('../../../shared/js/navbar');
var images = require('../../../shared/js/images');
var main = require('../../../shared/js/main');

var viewportwidth = window.innerWidth;
var downloadingImage = new Image();
var imgHomeSrc = 'https://res.cloudinary.com/eclimontessori/image/upload/c_scale,w_'+viewportwidth+'/v1572006261/IMG_2082_qsnvgm.jpg';
// downloadingImage.src = imgHomeSrc;
// downloadingImage.onload = function(){
//   document.getElementById("home").style.backgroundImage = "url("+imgHomeSrc+")";
// };


$(document).ready(function($){
  navbar();
  images();
  main();
  resizingVideo()
})

function resizingVideo() {
  // By Chris Coyier & tweaked by Mathias Bynens

$(function() {

	// Find all YouTube videos
	var $allVideos = $("iframe[src^='https://www.youtube.com']"), $fluidEl = $(".container");
	// Figure out and save aspect ratio for each video
	$allVideos.each(function() {

		$(this)
			.data('aspectRatio', this.height / this.width)

			// and remove the hard coded width/height
			.removeAttr('height')
			.removeAttr('width');

	});

	// When the window is resized
	// (You'll probably want to debounce this)
	$(window).resize(function() {

		var newWidth = $fluidEl.width();

		// Resize all videos according to their own aspect ratio
		$allVideos.each(function() {

			var $el = $(this);
			$el
				.width(newWidth)
				.height(newWidth * $el.data('aspectRatio'));

		});

	// Kick off one resize to fix all videos on page load
	}).resize();

});
}



//////////////////
// WEBPACK FOOTER
// ./app/pages/index/js/index.js
// module id = 14
// module chunks = 4